<template>
  <validation-observer ref="provider" v-slot="{ invalid }" slim>
    <form @submit.prevent="sendRegister" v-if="provider.hasOwnProperty('id')">
      <v-expansion-panels
        class="mb-12"
        v-if="providerClone"
        v-model="panel"
        multiple
        accordion
      >
        <ProvidersInfo
          :view="hideVisualizar"
          @setFields="setFields"
          :provider="providerClone"
        ></ProvidersInfo>
        <ProvidersAddress
          :view="hideVisualizar"
          @setFields="setFields"
          :provider="providerClone"
        ></ProvidersAddress>
        <ProvidersMoreInfo
          :view="hideVisualizar"
          @setFields="setFields"
          @setCnaes="setCnaes"
          :provider="providerClone"
        ></ProvidersMoreInfo>
        <ProvidersDocumentation
          :view="hideVisualizar"
          @hideBar="hideBar"
          @setFields="setFields"
        ></ProvidersDocumentation>
        <ProvidersBankInfo
          :view="hideVisualizar"
          @setFinances="setFinances"
          @hideBar="hideBar"
          :class="
            $route.query.user_gfs_token &&
            $route.name === 'providers.validation'
              ? ''
              : 'mb-12'
          "
          :provider="providerClone.finances"
        ></ProvidersBankInfo>
        <ProvidersValidation
          :view="hideVisualizar"
          :status="provider.status_register"
          :comment="provider.providers_register.note"
          @setFields="setFields"
          v-if="
            $route.query.user_gfs_token &&
              ($route.name === 'providers.validation' ||
                $route.name === 'providers.validation.visualizar') &&
              provider.status_register != 'approved'
          "
          class="mb-12"
          :provider="providerClone"
        ></ProvidersValidation>
      </v-expansion-panels>
      <div class="button-field pa-3" v-if="!hide">
        <v-row justify="center">
          <v-col cols="auto">
            <v-btn
              @click="back()"
              large
              rounded
              color="default"
              class="pr-15 pl-15 elevation-0"
            >
              <span
                class="icon-double-arrow-left"
                style="margin-right: 10px"
              ></span>
              VOLTAR
            </v-btn>
          </v-col>
          <v-col cols="auto" v-if="!hideVisualizar">
            <v-btn
              large
              rounded
              color="primary"
              class="pr-15 pl-15 elevation-0"
              :disabled="invalid"
              @click="sendRegister"
            >
              SALVAR
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </form>
  </validation-observer>
</template>

<script>
import { ValidationObserver } from "vee-validate";

import ProvidersMoreInfo from "./ProvidersMoreInfo";
import ProvidersAddress from "./ProvidersAddress";
import ProvidersBankInfo from "./ProvidersBankInfo/";
import ProvidersDocumentation from "./ProvidersDocumentation";
import ProvidersInfo from "./ProvidersInfo";
import ProvidersValidation from "./ProvidersValidation";

import storeClientTypes from "../../../clientTypes/_store";
import storeBank from "../../../banks/_store";
import storeAddress from "../../../addresses/_store";
import storeProvider from "../../../providers/_store";
import storeAuth from "../../../auth/_store";
import storeNotifications from "../../../notifications/_store";

import cloneDeep from "lodash/cloneDeep";
import _ from "lodash";

import { mapGetters, mapActions } from "vuex";

// import JWT from "../../../../api/jwt";

export default {
  props: ["pageTitle"],
  data: () => ({
    loadingSend: false,
    panel: [0, 1, 2, 3, 4, 5],
    providerClone: {},
    hide: false,
    cd_fornecedor: null
  }),
  components: {
    ValidationObserver,
    ProvidersMoreInfo,
    ProvidersAddress,
    ProvidersBankInfo,
    ProvidersDocumentation,
    ProvidersInfo,
    ProvidersValidation
  },

  computed: {
    ...mapGetters({
      provider: "$_provider/provider",
      meInGfs: "$_auth/meInGfs",
      me: "$_auth/me"
    }),
    hideVisualizar() {
      return (
        this.$route.name === "providers.visualizar" ||
        this.$route.name === "providers.validation.visualizar" ||
        !this.$can("edit")
      );
    }
  },

  methods: {
    async send() {
      if (!this.$route.query.user_gfs_token) {
        this.providerClone.status_register = "pending";
      }
      this.loadingSend = true;

      if (_.hasIn(this.me, "id")) {
        this.providerClone.user_id = this.me.id;
      }

      try {
        await this.updateProvider({
          id: this.providerClone.id,
          body: this.providerClone
        });
        await this.$store.dispatch(`$_messages/setErrors`, {
          message: `Cadastro realizado com sucesso.`,
          type: "success",
          title: "Success!",
          timeout: 12000
        });
        if (this.$route.query.user_gfs_token) {
          await this.$store.dispatch(`$_auth/logout`);
          this.$store.commit("$_auth/DELETE_ME_AUTHENTICATED");
          this.$router.push("/autenticacao");
        } else {
          this.$router.push("/");
        }
      } catch (error) {
        await this.$store.dispatch(`$_messages/setErrors`, {
          message: error.response.data.message,
          type: "error",
          title: "Success!",
          timeout: 12000
        });
      }
      this.loadingSend = false;
    },
    ...mapActions({
      getProvider: "$_provider/get",
      updateProvider: "$_provider/update",
      meInGfsAction: "$_auth/meInGfs"
    }),
    setFinances(finances) {
      this.providerClone.finances = finances;
    },
    setCnaes(cnaes) {
      this.providerClone.cnaes = cnaes.data;
    },
    setFields(items) {
      this.providerClone = Object.assign(this.providerClone, items.data);

      if (_.hasIn(this.meInGfs, "cd_usuario")) {
        this.providerClone.user_gfs_id = this.meInGfs.cd_usuario;
        this.providerClone.user_gfs_nm = this.meInGfs.nm_usuario;
      }
    },
    setStatus(items) {
      this.providerClone = Object.assign(this.providerClone, items.data);
    },
    hideBar(hide) {
      this.hide = hide;
    },
    async isPendingRegister(item) {
      if (
        item.providers_register.status_register == 2 ||
        item.providers_register.stage_register != 2
      ) {
        await this.$store.dispatch(`$_messages/setErrors`, {
          message: `Esse cadastro não se encontra pendente de cadastro.`,
          type: "error",
          title: "error!",
          timeout: 4000
        });
        this.$router.push("/");
      } else {
        return true;
      }
    },
    verifyAuth(me) {
      if (_.hasIn(me, "id") && !this.me.password_reset) return true;
      else return false;
    },

    async sendRegister() {
      await this.$store.dispatch("$_notifications/setAlert", {
        message: "Deseja finalizar o cadastro?",
        cancelTitle: "Não",
        actions: [
          {
            title: "Sim",
            action: this.send
          }
        ]
      });
    },
    async back() {
      if (this.$route.query.user_gfs_token) {
        await this.$store.dispatch(`$_auth/logout`);
        this.$store.commit("$_auth/DELETE_ME_AUTHENTICATED");
        this.$router.push("/autenticacao");
      } else {
        this.$router.push({ name: "modules" });
      }
    }
  },

  beforeCreate() {
    const STORE_CLIENT_TYPE_KEY = "$_clientTypes";
    const STORE_PROVIDER_KEY = "$_provider";
    const STORE_ADDRESS_KEY = "$_address";
    const STORE_NOTIFICATIONS = "$_notifications";
    const STORE_BANKS = "$_bank";
    const STORE_AUTH = "$_auth";

    if (!(STORE_CLIENT_TYPE_KEY in this.$store._modules.root._children))
      this.$store.registerModule(STORE_CLIENT_TYPE_KEY, storeClientTypes);

    if (!(STORE_NOTIFICATIONS in this.$store._modules.root._children))
      this.$store.registerModule(STORE_NOTIFICATIONS, storeNotifications);

    if (!(STORE_ADDRESS_KEY in this.$store._modules.root._children))
      this.$store.registerModule(STORE_ADDRESS_KEY, storeAddress);

    if (!(STORE_PROVIDER_KEY in this.$store._modules.root._children))
      this.$store.registerModule(STORE_PROVIDER_KEY, storeProvider);

    if (!(STORE_BANKS in this.$store._modules.root._children))
      this.$store.registerModule(STORE_BANKS, storeBank);

    if (!(STORE_AUTH in this.$store._modules.root._children))
      this.$store.registerModule(STORE_AUTH, storeAuth);
  },

  async created() {
    if (this.$route.query.user_gfs_token) {
      try {
        await this.meInGfsAction({ token: this.$route.query.user_gfs_token });
        await this.$store.dispatch(`$_messages/setErrors`, {
          message: `Logado(a) como ${this.meInGfs.nm_usuario}.`,
          type: "success",
          title: "Sucesso!",
          timeout: 4000
        });
        this.isUserGfs = true;
      } catch (error) {
        console.log(error);
        await this.$store.dispatch(`$_messages/setErrors`, {
          message: `Esse link expirou ou é invalido.`,
          type: "error",
          title: "Sucesso!",
          timeout: 4000
        });
        this.$router.push("/");
      }
    }
    if (this.verifyAuth(this.me)) this.cd_fornecedor = this.me.providers[0].id;
    else this.cd_fornecedor = this.$route.params.id;
    await this.getProvider(this.cd_fornecedor);
    if (this.$route.name == "providers.validation") {
      await this.isPendingRegister(this.provider);
    }
    this.providerClone = cloneDeep(this.provider);
  }
};
</script>

<style lang="scss">
.button-field {
  z-index: 9999;
  background-color: #c4c4c4b0;
  position: fixed;
  width: 100%;
  left: 0px;
  bottom: 0;
}
</style>
